import { module as Module } from 'modujs'
import gsap from 'gsap'
import { body } from '../utils/environment'

export default class extends Module {
  constructor(m) {
    super(m)

    this.links = this.$('link')
  }

  init() {
    this.currentTermPage()
  }

  hoverAddActive(slug) {
    const slugsString = slug
    const slugsArray = slugsString.split(' ')

    if (body.classList.contains('archive')) return

    this.links.forEach((link) => {
      gsap.to(link, {
        duration: 0.3,
        opacity: 0.5,
        ease: 'linear',
      })

      slugsArray.forEach((s) => {
        if (link.dataset.slug === s) {
          gsap.to(link, {
            duration: 0.3,
            opacity: 1,
            ease: 'linear',
          })

          link.classList.add('-is-active')
        }
      })
    })
  }

  hoverRemoveActive() {
    if (body.classList.contains('archive')) return

    this.links.forEach((link) => {
      gsap.to(link, {
        duration: 0.3,
        opacity: 1,
        ease: 'linear',
      })

      link.classList.remove('-is-active')
    })
  }

  currentTermPage() {
    if (!body.classList.contains('archive')) return

    this.links.forEach((link) => {
      gsap.to(link, {
        duration: 0.3,
        opacity: 0.5,
        ease: 'linear',
      })

      if (body.classList.contains(`term-${link.dataset.slug}`)) {
        gsap.to(link, {
          duration: 0.3,
          opacity: 1,
          textDecoration: 'underline',
          ease: 'linear',
        })
      }
    })
  }

  removeAllActive() {
    this.links.forEach((link) => {
      gsap.to(link, {
        duration: 0.3,
        opacity: 1,
        ease: 'linear',
        textDecoration: 'none',
      })

      link.classList.remove('-is-active')
    })
  }

  update() {
    this.removeAllActive()
    this.currentTermPage()
  }

  destroy() {
    this.removeAllActive()
  }
}
